// components/promotion/CategorySlider.js - Rebuilt with reliable SliderBar
import React from 'react';
import SliderBar from '../SliderBar';

const CategorySlider = ({
  categories = [],
  selectedCategory = 'All',
  onCategoryChange,
  onToggleSearch,
  onRefresh,
  showSearch = true,
  showRefresh = false,
  isRefreshing = false,
  lastUpdated = null,
  className = '',
  'aria-label': ariaLabel = 'Category filter'
}) => {
  return (
    <div role="navigation" aria-label={ariaLabel}>
      <SliderBar
        type="category"
        items={categories.filter(cat => cat !== 'All')}
        selectedItem={selectedCategory}
        onItemChange={onCategoryChange}
        onToggleSearch={onToggleSearch}
        onRefresh={onRefresh}
        showSearch={showSearch}
        showRefresh={showRefresh}
        isRefreshing={isRefreshing}
        lastUpdated={lastUpdated}
        className={className}
      />
    </div>
  );
};

export default CategorySlider;